import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useService } from '@kaokei/use-vue-service';
import { PlayerManagerService } from '@/services/exam/playerManager.service';
export default defineComponent({
  name: 'CustomAudio',
  props: {
    audioUrl: {
      type: String,
      required: true
    }
  },
  setup: function () {
    var audioRef = ref();
    var playerManagerService = useService(PlayerManagerService);
    var toggle = function () {
      playerManagerService.toggle(audioRef.value);
    };
    onMounted(function () {
      playerManagerService.add(audioRef.value);
    });
    onUnmounted(function () {
      playerManagerService.remove(audioRef.value);
    });
    return {
      audioRef: audioRef,
      toggle: toggle
    };
  }
});